/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AppState,
    AppStateFromJSON,
    AppStateToJSON,
} from '../models/AppState';

/**
 * 
 */
export class AppControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for state without sending the request
     */
    async stateRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/app/state`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async stateRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppState>> {
        const requestOptions = await this.stateRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppStateFromJSON(jsonValue));
    }

    /**
     */
    async state(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppState> {
        const response = await this.stateRaw(initOverrides);
        return await response.value();
    }

}
